import { useEffect } from "react";
import { Form, Input, InputNumber, Modal } from "antd";
import { AppImageUploader, EFileTypes } from "components";
import { MedicineContestPhoto, MedicineContestPhotoFormValues } from "./types";

type PhotoModalProps = {
  open: boolean;
  contestId: number;
  saving: boolean;
  photo?: MedicineContestPhoto;
  onCancel: () => void;
  onSubmit: (values: MedicineContestPhotoFormValues) => void;
};

export const PhotoModal = ({
  open,
  contestId,
  saving,
  photo,
  onCancel,
  onSubmit,
}: PhotoModalProps) => {
  const [form] = Form.useForm<MedicineContestPhotoFormValues>();

  useEffect(() => {
    if (!open) {
      return;
    }

    form.setFieldsValue({
      id: photo?.id,
      contestId,
      photoUrl: photo?.photoUrl || "",
    });
  }, [contestId, form, open, photo]);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    onSubmit(values);
  };

  return (
    <Modal
      title={photo ? "Редактировать фото" : "Добавить фото"}
      open={open}
      okText="Сохранить"
      cancelText="Отмена"
      confirmLoading={saving}
      onOk={handleSubmit}
      onCancel={onCancel}
      destroyOnClose
    >
      <Form<MedicineContestPhotoFormValues> form={form} layout="vertical">
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
        <Form.Item name="contestId" hidden>
          <Input />
        </Form.Item>

        <Form.Item
          name="photoUrl"
          label="Фото"
          rules={[
            {
              required: true,
              message: "Загрузите фото",
            },
          ]}
        >
          <AppImageUploader
            type="MEDICINE"
            entityId={`contests/${contestId}`}
            serviceType={EFileTypes.MEDICINE}
            cropperProps={{
              modalTitle: "Редактировать фото",
            }}
            uploadProps={{
              multiple: false,
              children: "Фото",
              listType: "picture-card",
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
